<template>
  <transition
    name="modal-fade"
    mode="out-in"
  >
    <div
      class="modal-overlay"
      @click.self="content.closing === 'disabled' ? null : closeModal()"
      v-show="showModal"
    >
      <div class="modal">
        <div class="modal-title">
          <template v-if="content.type !== undefined && content.type === 'close-button'">
            <standard-button
              text="Zamknij"
              @buttonClick="closeModal"
              :background-color="primaryColor"
              color="white"
            />
          </template>
          <template v-else>
            <h1
              class="secondary-heading modal-header"
              :style="{ fontFamily: fonts.secondary }"
            >
              {{ content.title }}
            </h1>
            <p
              class="subtitle"
              v-if="content.subtitle"
            >
              {{ content.subtitle }}
            </p>
            <button
              class="close-button"
              @click.esc="closeModal"
              v-if="content.closing !== 'disabled'"
            >
              <svg svg-inline="" class="icon-close" role="presentation" focusable="false" width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M31.6 15.4L15.4 31.6m0-16.2l16.3 16.3" stroke="currentColor" fill="none"/></svg>
            </button>
          </template>
        </div>
        <div
          v-if="content.html"
          class="modal-content"
          v-html="content.html"
        />
        <template v-else>
          <slot />
        </template>
        <div class="modal-buttons">
          <standard-button
            v-if="content.confirm"
            :text="content.confirm"
            @buttonClick="callback()"
            :background-color="thirdColor"
          />
          <standard-button
            v-if="content.cancel"
            :text="content.cancel"
            @buttonClick="closeModal"
            :text-color="primaryColor"
            class="cancel-button"
            class-type="secondary"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import StandardButton from '~/StandardButton';
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      content: 'modal/getContent',
      showModal: 'modal/showModal',
      thirdColor: 'brand/getThirdColor',
      primaryColor: 'brand/getPrimaryColor',
      callback: 'modal/getCallback',
      fonts: 'brand/getFonts',
    }),
  },
  components: {
    StandardButton,
  },
  methods: {
    ...mapActions({
      closeModal: 'modal/closeModal',
    }),
    handleKeyDown(event) {
      const { keyCode } = event;

      if (keyCode === 27) {
        this.closeModal();
      }
      if (this.content.confirm && keyCode === 13) {
        this.callback();
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown, false);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeyDown);
  },
};
</script>
